module.exports = __webpack_public_path__ + "52e5fa9d44c086c8bca451cddb7af94e.svg";